// Ukrainian translations
const uk = {
    "nav.home": "ГОЛОВНА",
    "nav.settings": "НАЛАШТУВАННЯ",
    "nav.exit": "ВИХІД",
    "nav.inventory": "ІНВЕНТАР",
    "nav.loadout": "СПОРЯДЖЕННЯ",
    "nav.play": "ГРАТИ",
    "nav.store": "МАГАЗИН",
    "nav.news": "НОВИНИ",
    "nav.friends": "ДРУЗІ",
    "nav.recordings": "ЗАПИСИ",
    "nav.profile": "ПРОФІЛЬ",

    "common.close": "Закрити",
    "common.back": "Назад",
    "common.save": "Зберегти",
    "common.cancel": "Скасувати",
    "common.confirm": "Підтвердити",
    "common.copy": "Копіювати",
    "common.share": "Поділитися",
    "common.locked": "Заблоковано",
    "common.unavailable": "Недоступно в Беті",
    "common.beta": "БЕТА",
    "common.online": "У мережі",
    "common.offline": "Поза мережею",

    "lobby.status": "ГОТОВИЙ ДО ВИСАДКИ",
    "lobby.slot_left": "Слот команди",
    "lobby.slot_right": "Слот команди",
    "lobby.slot_disabled": "Запрошення до групи недоступні в Бета-версії.",
    "lobby.mini_status": "ОЧІКУВАННЯ",

    "play.title": "РОЗГОРТАННЯ",
    "play.subtitle": "ОБЕРІТЬ МІСІЮ",
    "play.mode_training": "ТРЕНУВАННЯ",
    "play.mode_training_sub": "ПРОТИ ШІ · ОФЛАЙН",
    "play.mode_ranked": "РЕЙТИНГОВИЙ МУЛЬТИПЛЕЄР",
    "play.mode_ranked_sub": "ЗМАГАЛЬНИЙ · ОНЛАЙН",
    "play.available": "ДОСТУПНО",
    "play.beta_lock": "БЕТА БЛОК",
    "play.section_map": "КАРТА",
    "play.section_team": "РОЗМІР КОМАНДИ",
    "play.section_difficulty": "СКЛАДНІСТЬ БОТІВ",
    "play.deploy": "ВИСАДКА",
    "play.last_loadout": "ОСТАННЄ СПОРЯДЖЕННЯ",

    "store.title": "МАГАЗИН",
    "store.subtitle": "СКІНИ · КАПСУЛИ · НАБОРИ",
    "store.locked_title": "Магазин заблоковано",
    "store.locked_message": "Магазин недоступний у поточній збірці Бети.",

    "news.title": "НОВИНИ",
    "news.subtitle": "ПАТЧ-НОУТИ · ОГОЛОШЕННЯ",

    "loadout.title": "СПОРЯДЖЕННЯ",
    "loadout.subtitle": "ОСНОВНЕ · ДОДАТКОВЕ · БЛИЖНІЙ БІЙ · ГРАНАТИ",
    "loadout.slot_primary": "ОСНОВНЕ",
    "loadout.slot_secondary": "ДОДАТКОВЕ",
    "loadout.slot_melee": "БЛИЖНІЙ БІЙ",
    "loadout.slot_grenade": "ГРАНАТА",
    "loadout.slot_pistol_start": "СТАРТОВИЙ ПІСТОЛЕТ",
    "loadout.save": "Зберегти спорядження",
    "loadout.saved": "Спорядження збережено",

    "inventory.title": "ІНВЕНТАР",
    "inventory.subtitle": "БАЛАНС ЗБРОЇ · СКІНИ",

    "friends.title": "ДРУЗІ",
    "friends.subtitle": "ЗІБРАТИ ГРУПУ",
    "friends.add": "Додати друга",
    "friends.my_code": "Мій код друга",
    "friends.copy_code": "Копіювати код",
    "friends.reset_code": "Скинути код",
    "friends.incoming": "Вхідні запити",
    "friends.sent": "Надіслані запити",
    "friends.online": "У мережі",
    "friends.offline": "Поза мережею",
    "friends.blocked": "Заблоковані",
    "friends.search": "Пошук",
    "friends.remove": "Видалити",
    "friends.block": "Заблокувати",
    "friends.unavailable": "Онлайн-друзі недоступні під час Бети.",

    "recordings.title": "ЗАПИСИ",
    "recordings.subtitle": "РУЧНИЙ ЗАХОПЛЕННЯ КЛІПІВ",
    "recordings.start": "Почати новий запис",
    "recordings.stop": "Зупинити запис",
    "recordings.mine": "Мої записи",
    "recordings.play": "Відтворити",
    "recordings.rename": "Перейменувати",
    "recordings.delete": "Видалити",
    "recordings.download": "Завантажити",
    "recordings.experimental":
        "Запис у Беті експериментальний — використовуються API захоплення браузера, якість може змінюватися.",
    "recordings.indicator": "ЗАП",

    "exit.title": "Вийти з CROSSFIRE",
    "exit.message": "Ви впевнені, що хочете вийти з CROSSFIRE?",
    "exit.confirm": "ВИЙТИ З ГРИ",

    "profile.title": "ПРОФІЛЬ",
    "profile.subtitle": "ОПЕРАТОР",
    "profile.level": "РІВЕНЬ",
    "profile.xp": "ДОСВІД",
    "profile.matches": "МАТЧІ",
    "profile.wins": "ПЕРЕМОГИ",
    "profile.losses": "ПОРАЗКИ",
    "profile.kills": "ВБИВСТВА",
    "profile.deaths": "СМЕРТІ",
    "profile.kd": "K/D",
    "profile.rank": "РАНГ",
    "profile.rank_beta": "БЕЗ РАНГУ (БЕТА)",
    "profile.player_id": "ID ГРАВЦЯ",
    "profile.account": "АКАУНТ",
    "profile.account_beta": "ГІСТЬ БЕТИ",

    "settings.title": "НАЛАШТУВАННЯ",
    "settings.tab.graphics": "Графіка",
    "settings.tab.audio": "Звук",
    "settings.tab.controls": "Керування",
    "settings.tab.gameplay": "Ігровий процес",
    "settings.tab.language": "Мова",
};

export default uk;
